import gql from 'graphql-tag';

export const getBudgetSummary = gql`
  query getBudgetSummary($leaseId: String!) {
    getBudgetSummary(leaseId: $leaseId) {
      leaseId
      vehicleRego
      term
      currentMonth
      totalActual
      totalBudget
      totalVariance
      statementDocuments {
        url
        date
      }
      items {
        leaseId
        budgetCategory
        actual
        budget
        variance
      }
    }
  }
`;

export const getBudgetTransactions = gql`
  query getBudgetTransactions(
    $leaseId: String!
    $budgetCategory: String
    $startDate: Date!
    $endDate: Date!
  ) {
    getBudgetTransactions(
      leaseId: $leaseId
      budgetCategory: $budgetCategory
      startDate: $startDate
      endDate: $endDate
    ) {
      label
      transactionAmount
      date
    }
  }
`;
